import { render, staticRenderFns } from "./materialAuth.vue?vue&type=template&id=2c4b0b2e&"
import script from "./materialAuth.vue?vue&type=script&lang=js&"
export * from "./materialAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports